import { useSMSModalGuard } from "@/components/common/sms-wall/hooks/useSMSModalGuard";
import { useTranslation } from "next-i18next";
import { useCallback, useState } from "react";

export const useAccountSettingsPaymentInformationSMSGuard = () => {
  const [isEditable, setIsEditable] = useState(false);
  const [otpCode, setOtpCode] = useState<string | null>(null);

  const { t } = useTranslation();
  const { smsGuard } = useSMSModalGuard();

  const smsGuardExecutor = useCallback(
    async (oldValue?: unknown) => {
      const otp = await smsGuard({
        title: t(
          "account:your-account-settings-edit-payment-information-title"
        ),
        oldValue,
        newValue: "NEW",
      });

      if (!otp.pass()) {
        return;
      }

      setOtpCode(otp.getCode() ?? null);
      setIsEditable(true);
    },
    [smsGuard, t]
  );

  const smsGuardReset = useCallback(() => {
    setIsEditable(false);
    setOtpCode(null);
  }, []);

  return { isEditable, otpCode, smsGuard: smsGuardExecutor, smsGuardReset };
};
